import React, { useState } from "react";
import {
  aboutBanner,
  image,
  partner,
  headSalesForces,
  aiImg,
  businessHeadImg,
  uiUxHeadImg,
  contactHead,
  softwareHead,
  mobileHead,
  webHead,
  devopsHead,
  testimoHead,
  headCareers,
  headOurTeam,
} from "../../data/assetes";

import HomeHero from "./heroes/HomeHero";
import AboutHero from "./heroes/AboutHero";
import CareerHero from "./heroes/CareerHero";
import ContactHero from "./heroes/ContactHero";
import TestimonialsHero from "./heroes/TestimonialsHero";
import PartnershipHero from "./heroes/PartnershipHero";
import MobileAppHero from "./heroes/MobileAppHero";
import SoftwareHero from "./heroes/SoftwareHero";
import SalesforceHero from "./heroes/SalesforceHero";
import AIDevelopmentHero from "./heroes/AIDevelopmentHero";
import BusinessModernizationHero from "./heroes/BusinessModernizationHero";
import UiUxDesignHero from "./heroes/UiUxDesignHero";
import WebsiteDevelopmentHero from "./heroes/WebsiteDevelopmentHero";
import DevOpsHero from "./heroes/DevOpsHero";
import OurTeamHero from "./heroes/OurTeamHero";

const Banner = ({ container, location }) => {


  return (
    <>
      <div className="">
        {location?.pathname === "/" ? (
          <HomeHero

            image={image}
            container={container}
          />
        ) : location?.pathname === "/about" ? (
          <AboutHero
            title="About Us"
            image={aboutBanner}
            pathname={location?.pathname}
          />
        ) : location?.pathname === "/careers" ? (
          <CareerHero
            title="Carrier"
            image={headCareers}
            pathname={location?.pathname}
          />
        ) : location?.pathname === "/partnership" ? (
          <PartnershipHero title="Partner With Us" image={partner} />
        ) : location?.pathname === "/salesforce" ? (
          <SalesforceHero
            title="Salesforce Development Company"
            description={
              "As a Salesforce development company, Cybdeer creates automated, integrated, and tailored solutions on the Salesforce CRM platform. We build custom-fit solutions to meet your sales and marketing needs."
            }
            image={headSalesForces}
            pathname={location?.pathname}
          />
        ) : location?.pathname === "/ai-development" ? (
          <AIDevelopmentHero
            title="AI Development"
            description={
              "Are you ready to unlock your growth with a future vision? We at Cybdeer are ready to provide you with the best AI development services, including key concepts of machine learning, computer vision, cybersecurity, and data management, to build the best-suited AI for your business."
            }
            image={aiImg}
            pathname={location?.pathname}
          />
        ) : location?.pathname === "/business-modernization" ? (
          <BusinessModernizationHero
            title="Business Modernization"
            description={
              "Cybdeer provides solutions for updating your organization’s old technologies, cultures, and agility with new technologies to help you thrive in a competitive environment. This is achieved by adopting new technologies, re-engineering business processes, and improving the customer experience."
            }
            image={businessHeadImg}
            pathname={location?.pathname}
          />
        ) : location?.pathname === "/ui-ux-design" ? (
          <UiUxDesignHero
            title="UI UX Design "
            description={
              "Cybdeer is a leading mobile app development company with expertise in developing cross-platform and native mobile applications. Hire our dedicated Mobile app developers to build award-winning apps and give wings to your ideas."
            }
            image={uiUxHeadImg}
            pathname={location?.pathname}
          />
        ) : location?.pathname === "/contact-us" ? (
          <ContactHero
            title="Get in Touch "
            image={contactHead}
            pathname={location?.pathname}
          />
        ) : location?.pathname === "/mobile-app-development" ? (
          <MobileAppHero
            title="Mobile App Development"
            description={
              "Our top tier software development team provides custom software services that combine advanced technology that combine advanced technology with extensive industry experience."
            }
            image={mobileHead}
          />
        ) : location?.pathname === "/software-development" ? (
          <SoftwareHero
            title="Software Development"
            description={
              "As the premier software company, we empower your growth and innovation with a future-forward vision for software development. We focus on your long-term goals, ensuring you are equipped to thrive in this competitive environment."
            }
            image={softwareHead}
            pathname={location?.pathname}
          />
        ) : location?.pathname === "/website-development" ? (
          <WebsiteDevelopmentHero
            title="Web Development "
            description={
              "Web development is the process of building and maintaining websites. We provide a complete range of services, from initial creation to ongoing management, with the help of our expert front-end, back-end, and full-stack developers."
            }
            image={webHead}
            pathname={location?.pathname}
          />
        ) : location?.pathname === "/devops" ? (
          <DevOpsHero
            title="DevOps Services Solutions"
            description={
              "As a DevOps service provider, Cybdeer’s main goal is to shorten the software development lifecycle, enabling new features and increasing reliability. Our services are helpful for increasing speed, agility, quality, and reliability, as well as improving collaboration and cost efficiency."
            }
            image={devopsHead}
            pathname={location.pathname}
          />
        ) : location?.pathname === "/testimonials" ? (
          <TestimonialsHero
            title="Testimonial"
            image={testimoHead}
            container={container}
          />
        ) : location?.pathname === "/our-team" ? (
          <OurTeamHero
            title="Our Team"
            description="We have expert members in every field, each with over eight years of experience, which is helpful for your company's growth. As a top IT company, we are ready to serve your company with the best services."
            image={headOurTeam}
            container={container}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default Banner;
